// == Arrays == //
/**
 *
 * @param {Object} item
 * @returns Array
 */
Array.prototype.removeItem = function(item) {
    var index = this.indexOf(item);
    if (index > -1) {
        this.splice(index, 1);
    }
    return this;
}
